import { render, staticRenderFns } from "./FamilyMarketingCampaigns.vue?vue&type=template&id=44e19dc0&"
import script from "./FamilyMarketingCampaigns.vue?vue&type=script&lang=ts&"
export * from "./FamilyMarketingCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyMarketingCampaigns.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
